<template>
  <div class="video-card video-card-list">
    <div class="video-card-image">
      <router-link class="play-icon" :to="'/video/'+video_id">
        <i class="fas fa-play-circle"></i>
      </router-link>
      <router-link :to="'/video/'+video_id">
        <img class="img-fluid" :src="image_src" alt />
      </router-link>
      <div class="time">{{duration_human}}</div>
    </div>
    <div class="video-card-body">
      <!-- <div class="btn-group float-right right-action">
        <a
          href="#"
          class="right-action-link text-gray"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </a>

        <router-link
          :to="'/video/'+video_id"
          class="right-action-link text-gray"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </router-link>

        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#">
            <i class="fas fa-fw fa-star"></i> &nbsp; Top
            Rated
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-fw fa-signal"></i> &nbsp;
            Viewed
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-fw fa-times-circle"></i>
            &nbsp; Close
          </a>
        </div>
      </div>-->
      <div class="video-title">
        <router-link :to="'/video/'+video_id" class="fixt">{{title_text_short}}</router-link>
      </div>
      <div class="video-page text-success">
        {{category}}
        <router-link
          :to="'/video/'+video_id"
          title
          data-placement="top"
          data-toggle="tooltip"
          data-original-title="Verified"
        >
          <i class="fas fa-check-circle text-success"></i>
        </router-link>
      </div>
      <div class="video-view">
        {{views}} views &nbsp;
        <i class="fas fa-calendar-alt"></i>
        {{time_post}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Svideoinfocard",
  props: {
    title_text: String,
    sub_title_text: String,
    duration: Number,
    time_post: String,
    views: String,
    category: String,
    // image_src: {
    //   default: function() {
    //     return require("../img/v2.png");
    //   }
    // },
    image_src: String,
    video_id: String
  },
  computed: {
    title_text_short() {
      let num = 25;
      // if (this.title_text.length > num) {
      //   return this.title_text.slice(0, num);
      // }
      return this.title_text;
    },
    duration_human() {
      if (typeof this.duration === String) {
        return this.duration;
      } else {
        let drt = new Date(this.duration * 1000).toISOString().substr(11, 8);
        return drt;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$card-h: 90px;
$card-image-w: (122 * $card-h)/77;

.video-card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.video-title {
  flex-grow: 1;
}

.video-card-list {
  background: #fff;
  box-shadow: 0 0 11px #ececec;
  display: inline-block;
  margin-bottom: 1rem;
  width: 100%;
}
.video-card-list .video-card-body {
  padding: 0;
  margin: 0.5rem;
}
.fixt {
  // text-overflow: hidden;
  // white-space: pre-line;
  word-wrap: break-word;
  text-overflow: ellipsis;
  // overflow: hidden;
}
.video-card {
  display: flex;
  max-height: $card-h;
}
.video-card-list .video-card-image {
  float: left;
  height: $card-h;
  margin: 0 0 0 0;
  min-width: $card-image-w;
}
.img-fluid {
  min-width: $card-image-w;
  height: $card-h;
}
</style>
